// superpublicadmin

import axios from "axios";
import { getSuperAdminPublicConfig } from "../../ApiHelpers/ApiDefaultConfig";

export const fetchAdminList = async () => {
    let config = getSuperAdminPublicConfig()
    let result = null
    try {
        await axios.get(`/superpublicadmin/admin-list`, config)
            .then((res) => {
                result = res.data || []
            })
    } catch (error) {
        console.log(error)
    }

    if (result) {
        return result
    }

    return null
}


export const getAdminDetail = async (id) => {
    let config = getSuperAdminPublicConfig()
    let result = null
    try {
        await axios.get(`/superpublicadmin/get-admin-by-id/${id}`, config)
            .then((res) => {
                result = res.data || null
            })
    } catch (error) {
        console.log(error)
    }

    if (result) {
        return result
    }

    return null
}

export const cleanAdmin = async (name) => {
    let config = getSuperAdminPublicConfig()
    let result = null
    try {
        await axios.post(`/superpublicadmin/cleanSessionInfo/${name}`, {}, config)
            .then((res) => {
                result = res.data || null
            })
    } catch (error) {
        console.log(error)
    }

    if (result) {
        return result
    }
}
